import React from "react";
import { Card } from "@lightspeed/flame/Card";
import { Button } from "@lightspeed/flame/Button";

const CustomerToolbar = ({ activeTab, theme, onTabChange }) => {
  const renderTab = (tab, label) => (
    <Button
      size="small"
      className={`modern-tab ${activeTab === tab ? "modern-tab-active" : ""}`}
      active={activeTab === tab}
      onClick={() => onTabChange(tab)}
    >
      {label}
    </Button>
  );

  return (
    <Card
      className={`categories-bar ${theme === "flame" ? "" : "categories-bar-dark"}`}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 12px",
        borderRadius: 18,
      }}
    >
      <div className="modern-tab-container">
        {renderTab("types", "Customer Types")}
        {renderTab("customers", "Customers")}
      </div>
    </Card>
  );
};

export default CustomerToolbar;
